import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { Document, Page } from "react-pdf";
import { Spin } from "antd";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import styles from "./index.module.less";
import classNames from "classnames";
import { useLocale } from "@/hooks/useLocale";
const PdfPreview = ({ fileUrl, locale }) => {
    const previewContainerRef = useRef(null);
    const [numPages, setNumPages] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const { t } = useLocale("attachmentResume", locale);
    return (_jsx("div", { className: "", ref: previewContainerRef, style: { height: "100%" }, children: _jsx("div", { className: "", style: { height: "100%" }, children: _jsx(Document, { className: classNames(isLoading ? styles.pdfViewer : ""), file: fileUrl, onLoadSuccess: ({ numPages }) => {
                    setIsLoading(false);
                    setNumPages(Math.min(numPages, 10));
                }, loading: _jsx("div", { className: classNames(styles.pdfLoading), children: _jsxs("div", { className: classNames(styles.pdfLoadingBox), children: [_jsx(Spin, { spinning: true, size: "small" }), _jsx("span", { children: t("resumePreviewLoading") })] }) }), children: _jsx("div", { style: { width: "100%" }, children: Array.from({ length: numPages || 0 }, (_, index) => (_jsx("div", { style: {
                            marginBottom: "16px",
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                            borderRadius: "4px",
                        }, children: _jsx(Page, { pageNumber: index + 1, width: previewContainerRef.current?.offsetWidth
                                ? Math.min(previewContainerRef.current.offsetWidth - 10, previewContainerRef.current?.offsetWidth)
                                : 400, renderTextLayer: true, renderAnnotationLayer: false, loading: _jsx("div", { style: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }, children: _jsx(Spin, { spinning: true }) }) }) }, `page_${index + 1}`))) }) }) }) }));
};
export default PdfPreview;
